export const optionNew = {
    name: 'The NEWEST OPTION',
    optionTypeId: 1,
    trafficType: 'Voice',
    active: false,
    optionValues: [
        {
            value: 'dgfegfe',
            price: 2,
            cost: 2,
            maxDiscount: 0,
            units: 0,
            unitType: 'MB',
            costPerUnit: 0,
            userRole: [],
            productSegment: ['SME']
        },
        {
            value: 'neki kontent',
            price: 3,
            cost: 3,
            maxDiscount: 0,
            units: 3,
            unitType: 'MB',
            costPerUnit: 3,
            productSegment: ['SME']
        },
        {
            value: 'sdadsa',
            price: 2,
            cost: 2,
            maxDiscount: 0,
            units: 0,
            unitType: 'MB',
            costPerUnit: 0,
            userRole: [],
            productSegment: ['SME']
        }
    ]
};
export const optionEdit = {
    id: 10,
    name: 'TEST',
    optionTypeId: 1,
    trafficType: 'Voice',
    active: false,
    optionValues: [
        {
            value: 'dgfegfe',
            price: 2,
            cost: 2,
            maxDiscount: 0,
            units: 0,
            unitType: 'MB',
            costPerUnit: 0,
            userRole: [],
            productSegment: ['SME']
        },
        {
            value: 'neki kontent',
            price: 3,
            cost: 3,
            maxDiscount: 0,
            units: 3,
            unitType: 'MB',
            costPerUnit: 3,
            productSegment: ['SME']
        },
        {
            value: 'sdadsa',
            price: 2,
            cost: 2,
            maxDiscount: 0,
            units: 0,
            unitType: 'MB',
            costPerUnit: 0,
            userRole: [],
            productSegment: ['SME']
        }
    ]
};
export const mockForm = {
    text: '43543',
    number: '34534',
    percentage: '345',
    date: '2023-12-21',
    currency: '345',
    singleSelect: {
        value: 'Option 1',
        label: 'Option 1'
    },
    multiSelect: [
        {
            value: 'Option 2',
            label: 'Option 2'
        },
        {
            value: 'Option 4',
            label: 'Option 4'
        }
    ],
    checkbox: true,
    radio: '',
    list: [
        { firstName: 'Prvi', lastName: 'Prvic', email: 'prvi@prvi.com', age: 23 },
        { firstName: 'Drugi', lastName: 'Drugic', email: 'drugi@drugi.com', age: 30 }
    ]
};
export const mockListDefinition = [
    {
        id: 1666666,
        name: 'firstName',
        label: 'First Name',
        description: 'Enter First Name',
        fieldType: 'text',
        validation: {
            required: true,
            pattern: {
                message: 'Use only letters',
                value: '[A-Za-z]+$' // only letters
            },
            minLength: 3
        }
    },
    {
        id: 26666666,
        name: 'lastName',
        label: 'Last Name',
        description: 'Enter Last Name',
        fieldType: 'text',
        validation: {
            required: true,
            pattern: {
                message: 'Use only letters',
                value: '[A-Za-z]+$' // only letters
            },
            maxLength: 10
        }
    },
    {
        id: 66666666,
        name: 'email',
        label: 'Email',
        description: 'Enter Email',
        fieldType: 'text',
        validation: {
            required: true,
            pattern: {
                message: 'Email is invalid',
                value: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
            }
        }
    },
    {
        id: 3666666,
        name: 'age',
        label: 'Age',
        description: 'Enter Age',
        fieldType: 'number',
        validation: {
            required: true,
            min: 18,
            max: 100
        }
    }
];
export const mockDefinition = [
    {
        id: 1,
        name: 'text',
        label: 'Field 1 [email]',
        description: 'Description for Field 1',
        fieldType: 'email',
        validation: {
            required: true,
            pattern: {
                value: '^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$',
                message: 'Email is invalid'
            }
        }
    },
    {
        id: 2,
        name: 'number',
        label: 'Field 2 [number]',
        description: 'Description for Field 2',
        fieldType: 'number',
        validation: {
            required: true
        }
    },
    {
        id: 7,
        name: 'percentage',
        label: 'Field 3 [percentage]',
        description: 'Description for Field 2',
        fieldType: 'percentage',
        validation: {
            required: true
        }
    },
    {
        id: 8,
        name: 'date',
        label: 'Field 4 [date]',
        description: 'Description for Field 2',
        fieldType: 'date',
        validation: {
            required: true
        }
    },
    {
        id: 3,
        name: 'currency',
        label: 'Field 5 [currency]',
        description: 'Description for Field 3',
        fieldType: 'currency',
        validation: {
            required: true
        }
    },
    {
        id: 4,
        name: 'singleSelect',
        label: 'Field 6 [singleSelect]',
        description: 'Description for Field 4',
        fieldType: 'singleSelect',
        options: ['Option 1', 'Option 2', 'Option 3'],
        validation: {
            required: true
        }
    },
    {
        id: 5,
        name: 'multiSelect',
        label: 'Field 5 [multiSelect]',
        description: 'Description for Field 4',
        fieldType: 'multiSelect',
        options: ['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5', 'Option 6'],
        validation: {
            required: true
        }
    },
    {
        id: 6,
        name: 'checkbox',
        label: 'Field 7 [checkbox]',
        description: 'Description for Field 5',
        fieldType: 'checkbox'
    },
    {
        id: 9,
        name: 'radio',
        label: 'Field 8 [radio]',
        description: 'Description for Field 6',
        fieldType: 'radio',
        options: [
            { value: 'true', label: 'True' },
            { value: 'false', label: 'False' }
        ]
    }
];
export const tableData = [
    { id: 1, name: 'product 1', price: 100 },
    { id: 2, name: 'product 2', price: 200 },
    { id: 3, name: 'product 3', price: 300 },
    { id: 4, name: 'product 4', price: 400 },
    { id: 5, name: 'product 5', price: 500 },
    { id: 6, name: 'product 6', price: 600 },
    { id: 7, name: 'product 7', price: 700 },
    { id: 8, name: 'product 8', price: 800 },
    { id: 9, name: 'product 9', price: 900 },
    { id: 10, name: 'product 10', price: 1000 },
    { id: 11, name: 'product 11', price: 1100 },
    { id: 12, name: 'product 12', price: 1200 },
    { id: 13, name: 'product 13', price: 1300 },
    { id: 14, name: 'product 14', price: 1400 },
    { id: 15, name: 'product 15', price: 1500 },
    { id: 16, name: 'product 16', price: 1600 },
    { id: 17, name: 'product 17', price: 1700 },
    { id: 18, name: 'product 18', price: 1800 },
    { id: 19, name: 'product 19', price: 1900 },
    { id: 20, name: 'product 20', price: 2000 },
    { id: 21, name: 'product 21', price: 2100 },
    { id: 22, name: 'product 22', price: 2200 },
    { id: 23, name: 'product 23', price: 2300 },
    { id: 24, name: 'product 24', price: 2400 },
    { id: 25, name: 'product 25', price: 2500 },
    { id: 26, name: 'product 26', price: 2600 },
    { id: 27, name: 'product 27', price: 2700 },
    { id: 28, name: 'product 28', price: 2800 },
    { id: 29, name: 'product 29', price: 2900 },
    { id: 30, name: 'product 30', price: 3000 }
];
export const tableColumns = [
    {
        dataField: 'id',
        text: 'Product ID'
    },
    {
        dataField: 'name',
        text: 'Product Name'
    },
    {
        dataField: 'price',
        text: 'Product Price'
    }
];
